document.addEventListener("DOMContentLoaded", ()=>{
    const listContainer = document.getElementById("post-toc-list");

    if(listContainer){
        const headingsAndSummaries = scanDocumentForHeadingsAndSummaries();
        printTableOfContent(listContainer, headingsAndSummaries);
    }
});

// Function to scan the HTML document and extract <h2> and <summary> tags
function scanDocumentForHeadingsAndSummaries() {
    const postContent = document.querySelector(".wp-block-post-content");
    // .wp-block-post-content/  
    // Get all <h2> and <summary> elements in the document
    const headingsH2 = postContent.querySelectorAll('h2:not(.is-style-mb-heading-no-toc)');
    const headingsH3 = postContent.querySelectorAll('h3:not(.is-style-mb-heading-no-toc)');

    // Create an array to store the combined headings and summaries
    const combined = [];

    // Iterate over the headings and add them to the combined array
    headingsH2.forEach(heading => {
        if(heading.id !== "post-toc-title-text"){
            combined.push({ type: 'h2', element: heading, title:heading.textContent });
        }
    });

    headingsH3.forEach(heading => {
        if(heading.id !== "post-toc-title-text"){
            combined.push({ type: 'h3', element: heading, title:heading.textContent });
        }
    });

    // Sort the combined array based on their position in the document
    combined.sort((a, b) => {
        return a.element.offsetTop - b.element.offsetTop;
    });

    return combined;
}


function printTableOfContent(tocList, elements){
    
    if(!tocList || !elements){ return;}

    tocList.setAttribute("id", "post-toc-list");

    elements.forEach( (el, idx)=>
        {
            const listItem =  document.createElement("li");
            listItem.textContent   = el.title;
            listItem.setAttribute("data-ac-toc", idx);
            listItem.setAttribute("class", `${el.type} toc-item`);
            el.element.setAttribute("data-ac-content", idx);
            tocList.appendChild(listItem);
        }   
     );
     tocList.addEventListener("click", listClickHandler);
}

function listClickHandler(e){
    const targetElement = e.target;

    if(targetElement.tagName.toLowerCase() !== "li"){
        return;
    }

    const tocIdx        = targetElement.getAttribute("data-ac-toc");
    const target        = document.querySelector(`[data-ac-content="${tocIdx}"]`);
    const stickyMenu    = document.getElementById("header-sticky-desktop");
    const parentElement = target.parentElement;

    if(parentElement.classList.contains( "wp-block-details" )){
        parentElement.setAttribute("open", true);
    }

    if(target && stickyMenu){
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const stickyMenuHeight = stickyMenu.offsetHeight;
    
        window.scrollTo({
            top: targetTop - 40 - stickyMenuHeight,
            behavior: "smooth"
        })
    }

}